module.exports = __webpack_public_path__ + "static/media/newStatus.41758ff5.svg";